import styled from 'styled-components';

export const ModelViewerWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 0;
  background-color: #000000;
  overflow: hidden;

  canvas {
    display: block;
    width: 100% !important;
    height: 100% !important;
    outline: none;
  }
`;

export const UIOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  pointer-events: none;
  
  display: flex;
  justify-content: flex-end; /* Alineado a la derecha */
  align-items: flex-end;     /* Alineado abajo */
  
  /* CAMBIO 1: Quitamos el padding aquí porque causaba el corte */
  padding: 0; 
`;

export const MapWrapper = styled.div`
  position: relative; 
  pointer-events: none;
  
  /* CAMBIO 2: Añadimos el espacio aquí.
     Al estar en un flex-end, el margen empuja el elemento "hacia adentro"
     separándolo del borde de la pantalla. */
  margin-right: 30px;
  margin-bottom: 30px;

  /* Dejamos que la imagen decida el tamaño */
  width: auto;
  height: auto;
`;

export const MapImage = styled.img`
  display: block; 
  
  /* Ajusta este valor si quieres el mapa más grande o pequeño */
  max-height: 40vh; 
  
  width: auto;
  max-width: 100%;

  opacity: 0.9;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.5);
`;

export const MapPoint = styled.button`
  position: absolute;
  top: ${props => props.$top}%;
  left: ${props => props.$left}%;
  transform: translate(-50%, -50%);
  
  width: 24px;
  height: 24px;
  
  /* Estilo base (Azul) */
  background-color: #007bff;
  border: 2px solid white;
  color: white;
  border-radius: 50%;
  
  font-weight: bold;
  font-family: sans-serif;
  font-size: 14px;
  
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  cursor: pointer;
  pointer-events: auto;
  transition: all 0.2s ease-in-out;

  /* --- ESTILOS DEL HOVER --- */
  &:hover {
    background-color: #ff0000;
    transform: translate(-50%, -50%) scale(1.2);
    z-index: 100; 
  }

  /* --- TOOLTIP (TEXTO FLOTANTE) --- */
  &:hover::after {
    /* Aquí ocurre la magia: CSS lee el texto del atributo HTML */
    content: attr(data-label);
    
    position: absolute;
    bottom: 140%; /* Que flote un poco más arriba del punto */
    left: 50%;
    transform: translateX(-50%);
    
    background-color: rgba(0, 0, 0, 0.85);
    color: white;
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap; /* Que el texto no se parta */
    pointer-events: none;
    
    /* Animación suave */
    animation: fadeIn 0.2s forwards;
  }
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateX(-50%) translateY(5px); }
    to { opacity: 1; transform: translateX(-50%) translateY(0); }
  }
`;

export const DebugButton = styled.button`
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 9999;
  pointer-events: auto;
  
  padding: 10px 15px;
  background-color: white;
  color: #333;
  font-weight: bold;
  font-family: monospace;
  
  border: 2px solid #ccc;
  border-radius: 8px;
  cursor: pointer;
  
  /* Sombra suave */
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  
  /* Transición suave para todos los cambios */
  transition: all 0.2s ease;

  /* EFECTO HOVER (Al pasar el ratón) */
  &:hover {
    background-color: #f0f0f0;
    border-color: #999;
    transform: translateY(-2px); /* Se eleva un poquito */
    box-shadow: 0 6px 8px rgba(0,0,0,0.2);
  }

  /* EFECTO ACTIVE (Al hacer clic) */
  &:active {
    background-color: #e0e0e0;
    transform: translateY(1px); /* Se hunde al pulsar */
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
`;